<template>
  <div class="home">
    <first></first>
     <!-- <second></second>
    <third></third>
    <four></four> -->
    <six></six>
    <five></five>
    <dcFooter></dcFooter>
  </div>
</template>

<script>
// @ is an alias to /src
import first from "../components/main/first.vue";
// import second from "../components/main/second.vue";
// import third from "../components/main/third.vue";
// import four from "../components/main/four.vue";
import five from "../components/main/five.vue";
import six from "../components/main/six.vue";
import dcFooter from "../components/main/dcFooter.vue";
export default {
  name: "Home",
  components: {
    first,
    // second,
    // third,
    // four,
    five,
    six,
    dcFooter
  }
};
</script>
<style scoped lang="less">
.home {
  width: 100vw;
  // overflow:hidden;
}
</style>
	
